"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ready_icon_1 = require("../../../../svg/status/ready.icon");
var onPhone_icon_1 = require("../../../../svg/status/onPhone.icon");
var wrapUp_icon_1 = require("../../../../svg/wrapUp.icon");
var idle_icon_1 = require("../../../../svg/status/idle.icon");
var ringing_icon_1 = require("../../../../svg/status/ringing.icon");
var loggedOut_icon_1 = require("../../../../svg/status/loggedOut.icon");
var queueBusy_icon_1 = require("../../../../svg/status/queueBusy.icon");
function StatusIcon(props) {
    var icon = null;
    switch (props.status) {
        case "ready":
            icon = React.createElement(ready_icon_1.ReadyIcon, null);
            break;
        case "onphone":
            icon = React.createElement(onPhone_icon_1.OnPhoneIcon, null);
            break;
        case "busy":
            icon = React.createElement(queueBusy_icon_1.QueueBusyIcon, null);
            break;
        case "wrapup":
            icon = React.createElement(wrapUp_icon_1.WrapUpIcon, null);
            break;
        case "idle":
            icon = React.createElement(idle_icon_1.IdleIcon, null);
            break;
        case "calling":
            icon = React.createElement(ringing_icon_1.RingingIcon, null);
            break;
        case "loggedout":
            icon = React.createElement(loggedOut_icon_1.LoggedOutIcon, null);
            break;
    }
    return icon;
}
exports.StatusIcon = StatusIcon;
